import API from 'utils/api';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/percepciones-issste/';
/**
 * GET UMAS Generales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPercepcionesISSSTE = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
   * GET TipoDeSeguridadSocial
   * @param {number} id
   * @returns {Promise<object|null>}
   */
export const getPercepcionISSSTE = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
   * POST TipoDeSeguridadSocial
   * @param {object} values
   * @returns {Promise<object|boolean>}
   */
export const postPercepcionISSSTE = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
   * PATCH TipoDeSeguridadSocial
   * @param {number} id
   * @param {object} values
   * @returns {Promise<object|boolean>}
   */
export const patchPercepcionISSSTE = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE TipoDeSeguridadSocial
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePercepcionISSSTE = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR TipoDeSeguridadSocial
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarPercepcionISSSTE = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
